import React, { Fragment } from 'react'
import AuthPage from './AuthPage'
import { anonymous } from 'routes/config/user'
import { Route, Routes, useLocation } from 'react-router-dom'
import Page from 'modules/Page/Container/index'

const AuthRouter = ({ isAuthenticated, getStudentData, SignIn }) => {
  const location = new useLocation()
  console.log(location, 'location')
  return (
    <Fragment>
      {location?.pathname?.includes('activate') ||
      location?.pathname?.includes('not-interested') ? (
        <Page isOnboarding={true}>
          <Routes>
            {anonymous?.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                />
              )
            })}
          </Routes>
        </Page>
      ) : (
        <AuthPage
          isAuthenticated={isAuthenticated}
          getStudentData={getStudentData}
          SignIn={SignIn}
        />
      )}
    </Fragment>
  )
}

export default AuthRouter